import VueTimepicker from './vue-timepicker.vue'
export default VueTimepicker
